import React from "react";

const InsiderActivity = ({
  selectedStock,
  insiderTransactions,
  formatCurrency,
}) => {
  return (
    <div className="insider-activity">
      <h4>Recent Insider Activity</h4>
      <div className="insider-transactions">
        <table className="insider-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Insider</th>
              <th>Title</th>
              <th>Transaction</th>
              <th>Shares</th>
              <th>Price</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {insiderTransactions
              .filter(
                (transaction) => transaction.symbol === selectedStock.symbol
              )
              .map((transaction, index) => (
                <tr key={index}>
                  <td>{transaction.date}</td>
                  <td>{transaction.insider}</td>
                  <td>{transaction.title}</td>
                  <td className={transaction.type === "Buy" ? "buy" : "sell"}>
                    {transaction.type}
                  </td>
                  <td>{transaction.shares.toLocaleString()}</td>
                  <td>{formatCurrency(transaction.price)}</td>
                  <td>
                    {formatCurrency(transaction.price * transaction.shares)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InsiderActivity;
